import { AxisBase } from './AxisBase';
import { IAxis } from './IAxis';

export class HorizontalAxis extends AxisBase implements IAxis {

    constructor(width: number, private min: number, private max: number, ticksCount: number, container) {
        super('bottom', width, min, max, ticksCount, container);
    }

    width(): number {
        return this.size();
    }

    height(value?: number): number {
        const height = this.space(value);
        const ratio = this.ratio() || 1;
        this.group()
            .select('.axis-title')
            .attr({
                'transform': `translate(${(this.width()) / 2},${(this.titleHeight + this.tickSize()) * ratio})`
            });
        return height;
    }
}